module.exports = function getResource(label) {
    let resources = {
        secure: 'Sûr',
        edit: 'Modifier',
        shippingTo: 'Expédier à',
        pickUpOrderContactInfo: 'Personne qui ramassera la commande',
        pickUpOrderLocationInfo: 'Lieu du ramassage',
        giftCardShippingAddress: 'Adresse de livraison pour la carte-cadeau',
        giftCardDeliveryMessage: 'Livraison et message de la carte-cadeau',
        shippingAddress: 'Adresse de livraison',
        deliveryGiftOptions: 'Options de livraison et de cadeau',
        paymentMethod: 'Mode de paiement',
        accountCreation: 'Création du compte',
        reviewPlaceOrder: 'Vérifier et passer la commande',
        shippingDelivery: 'Expédition et livraison',
        reviewSubmitEditsTitle: 'Vérifier et soumettre les modifications',
        reviewSubmitSubscribeTitle: 'Vérifier et s’inscrire',
        updatedBadge: 'MIS À JOUR'
    };

    return resources[label];
};
